import Konva from 'konva'
import Element from './element.es6'

const font = { family: 'Roboto', color: 'rgba(0,0,0,0.54)' }

const alignToX = (align, width) => {
  switch (align) {
    case 'left':
      return 0
    case 'center':
      return -width / 2
    case 'right':
      return -width
  }
}

export default class Text extends Element {
  setDefaultShapes () {
    const { text, fontSize, horizontalAlign } = this.meta
    const shape = new Konva.Text({
      x: 0,
      y: 0,
      text: text,
      fontSize: fontSize,
      fontFamily: font.family,
      fill: font.color,
      align: horizontalAlign
    })
    shape.setX(alignToX(horizontalAlign, shape.getWidth()))
    this.shapes = [shape]
  }

  applyStatusOnShapes () {
  }
}
